import React, { FunctionComponent, useEffect, useState, useMemo, useCallback, useRef, useLayoutEffect } from 'react';
import { CountUp } from 'use-count-up'
import { ISpeedCardData } from '../context'
import cx from 'classnames';
import styles from './index.module.less';

interface IProps {
  id: string;
  dataSource: ISpeedCardData[];
}

const Speedways: FunctionComponent<IProps> = ({ id, dataSource }) => {
  const targetRef = useRef<HTMLUListElement>(null);
  const speedRef = useRef<HTMLDivElement>(null);
  const [isShow, setShow] = useState<boolean>(false);

  const scrollTo = (scrollValue) => {
    let scrollLeft = targetRef.current!.scrollLeft;
    targetRef.current!.scrollTo(scrollLeft + scrollValue, 0);
  }

  useLayoutEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        !isShow && setShow(true)
      }
    },  { threshold: [0.65] })

    speedRef.current && observer.observe(speedRef.current);
  }, [dataSource, isShow])
  
  return (
    <div className={styles['speed-ways']} ref={speedRef}>
      <div className={styles['title']}>
        <h4>超級測試賽道成績 </h4>
        <a href="https://c.8891.com.tw/supertest/speedway">{' >>'}</a>
      </div>
      <div className={cx(styles['speed-ways-box'])}>
        <div className={styles['dash-board']}>
          <div className={styles['dash-board-item']}><i className={isShow && styles['board-animate']}></i></div>
          <div className={styles['dash-board-item']}><i className={isShow && styles['board-animate']}></i></div>
        </div>
        { dataSource.length > 3 && <div className={styles['prev']} id="speed-ways-prev" onClick={() => scrollTo(-788)}></div> }
        <div id='speed-ways-car' className={cx(styles['speed-ways-car'], { [styles['box-more']]: dataSource.length > 3 })} ref={targetRef}>
          {
            dataSource.map((item, inx) => (
              <div className={cx(styles['car-item'], {[styles['car-item-big']]: dataSource.length === 1})} key={inx}>
                <h5>{item.fullName}</h5>
                <div className={styles['car-speed']}>
                  <CountUp isCounting={isShow} end={isShow ? Number(item.speed) : 0} duration={3} />秒
                </div>
                <img className={cx(styles['car-thumb'], {[styles['car-animate']]: isShow})} src={item.thumb} />
                <div className={styles['speed-way-list']}>
                  時間:{item.date} 
                  天氣:{item.weather} 
                  <br />
                  溫度:{item.temperature}  
                  賽道:{item.speedwayName}
                </div>
                {!!item.isCompare && <div className={styles['compare']}>比較</div>}
              </div>
            ))
          }
        </div>


        { dataSource.length > 3 && <div className={styles['next']} id="speed-ways-next" onClick={() => scrollTo(788)}></div> }
      </div>
      <div className={styles['speed-bg']}></div>
    </div>
  )
}

export default Speedways;